import Vue from "vue";
import Vuex from "vuex";
import { api } from "../api/api.js";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    categories: JSON.parse(window.localStorage.getItem("categories")) || [],
    modules: JSON.parse(window.localStorage.getItem("modules")) || [],
    modulesMain: JSON.parse(window.localStorage.getItem("modulesMain")) || [],
    modulesFeatured:
      JSON.parse(window.localStorage.getItem("modulesFeat")) || [],
    actualContent: null,
    postList: [],
    actualPost: null,
    faq: [],
    searchArticleList: [],
    actualModule: null
  },
  getters: {
    postListGetter: state => {
      return state.postList;
    },
    postGetter: state => {
      return state.actualPost;
    },
    categoriesGetter: state => {
      return state.categories;
    },
    modulesGetter: state => {
      return state.modules;
    },
    modulesMainlistGetter: state => {
      return state.modulesMain;
    },
    modulesFeaturedGetter: state => {
      return state.modulesFeatured;
    },
    faqGetter: state => {
      return state.faq;
    },
    subModulesList: state => module => {
      console.log(module, state.modules);
      return state.modules.filter(mod => mod.slug === module)[0];
    },
    actualContentSupport: state => {
      if (!state.actualContent) return null;
      return state.actualContent;
    },
    actualModuleGetter: state => {
      if (!state.actualModule) return {};
      return state.actualModule;
    }
  },
  mutations: {
    ["SET_CATEGORIES"](state, payload) {
      state.categories = Array.from(payload);
    },
    ["SET_MODULES"](state, payload) {
      state.modules = Array.from(payload);
    },
    ["SET_MODULESMAIN"](state, payload) {
      state.modulesMain = Array.from(payload);
    },
    ["SET_MODULESFEATURED"](state, payload) {
      state.modulesFeatured = Array.from(payload);
    },
    ["SET_CONTENT"](state, payload) {
      state.actualContent = JSON.parse(JSON.stringify(payload));
    },
    ["SET_POSTLIST"](state, payload) {
      state.postList = Array.from(payload);
    },
    ["SET_ACTUALPOST"](state, payload) {
      state.actualPost = Object.assign({}, payload);
    },
    ["SET_FAQ"](state, payload) {
      state.faq = Array.from(payload);
    },
    ["SET_SEARCHLIST"](state, payload) {
      state.searchArticleList = Array.from(payload);
    },
    ["SET_ACTUALMODULE"](state, payload) {
      state.actualModule = JSON.parse(JSON.stringify(payload));
    }
  },
  actions: {
    getCategories: async ({ commit }) => {
      let res = await api.categoriesBlog();
      if (res.status == 200) {
        commit("SET_CATEGORIES", res.data);
        window.localStorage.setItem("categories", JSON.stringify(res.data));
      }
      return res;
    },
    getPostList: async ({ commit }) => {
      let res = await api.blogPostsList();
      if (res.status == 200) {
        commit("SET_POSTLIST", res.data);
      }
      return res;
    },
    getPost: async ({ commit }, payload) => {
      let res = await api.blogPost(payload);
      if (res.status == 200) {
        commit("SET_ACTUALPOST", res.data);
      }
      return res;
    },
    getFaq: async ({ commit }, payload) => {
      let res = await api.faq(payload);
      if (res.status == 200) {
        commit("SET_FAQ", res.data);
      }
      return res;
    },
    getModules: async ({ commit }) => {
      let res = await api.supportModules();
      if (res.status == 200) {
        commit("SET_MODULES", res.data);
        window.localStorage.setItem("modules", JSON.stringify(res.data));
      }
      return res;
    },
    getModulesMainlist: async ({ commit }) => {
      let res = await api.supportModulesMainlist();
      if (res.status == 200) {
        commit("SET_MODULESMAIN", res.data);
        window.localStorage.setItem("modulesMain", JSON.stringify(res.data));
      }
      return res;
    },
    getModulesFeatured: async ({ commit }) => {
      let res = await api.supportModulesFeatured();
      if (res.status == 200) {
        commit("SET_MODULESFEATURED", res.data);
        window.localStorage.setItem("modulesFeat", JSON.stringify(res.data));
      }
      return res;
    },
    getModuleDetail: async ({ commit }, payload) => {
      let res = await api.supportModulesDetail(payload);
      if (res.status === 200) {
        commit("SET_ACTUALMODULE", res.data);
      }
      return res;
    },
    getSupportContent: async ({ commit }, payload) => {
      let res = await api.supportContent(payload);
      if (res.status == 200) {
        commit("SET_CONTENT", res.data);
      }
      return res;
    },
    searchSupport: async ({ commit }, payload) => {
      let res = await api.supportSearch(payload);
      if (res.status === 200) {
        commit("SET_SEARCHLIST", res.data);
      }
      return res;
    }
  },
  modules: {}
});
